/* eslint no-nested-ternary: "off" */
/* eslint no-param-reassign: "off" */

import axios from 'axios';

import { AxiosError } from 'api/axios';
import { API_TIMEOUTS, apiBaseURL } from 'api/settings';
import * as errors from 'common/errors';

export default async function postConfirmSubscribe({
  campaignKey,
  emailAddress,
  customFields,
}: {
  campaignKey: string;
  emailAddress: string;
  customFields?: Record<string, string>;
}) {
  let campaignURN = campaignKey;
  if (campaignKey.split(':').length === 1) {
    campaignURN = `urn:newsletter:campaign:${campaignKey}`;
  }

  const config = {
    url: `${apiBaseURL()}/public/campaigns/subscribe/confirm`,
    method: 'POST',
    timeout: API_TIMEOUTS.S,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      campaignURN,
      email: btoa(emailAddress),
      customFields,
    }),
  };

  try {
    const response = await axios(config);
    return response.headers.location;
  } catch (error) {
    const apiError =
      error instanceof AxiosError
        ? error.message
        : error instanceof Error
          ? // @ts-expect-error need to sort this out one day
            await errors.handleAPIError({ originalError: error })
          : error;
    throw apiError;
  }
}
